import React, { useContext, useState } from 'react';
import { InputField, RadioGroupField } from '@trp-beacon-ui-kit/react-controls';
import styles from './style.css';
import { FlowContext } from '../../core/flow-engine';
import { invalidCitizenshipValue, mapCitizenshipToSsnLabel } from './util';
import { MFBeaconButton } from '../Beacon/BeaconComponents';
import {
  formatSsnForDisplay,
  handleInputFormat
} from '../../flows/shared/utils';
import { middlenameValidation } from '../../flows/shared/validations';
import { withDefault } from '../../core/util';
import { generateJointOrCoTrustTestID } from '../../generateAutomationTestIDs';

const CoTrusteePIDetails = ({ key, getDefault, makeName, removeSection }) => {
  const {
    formProps: {
      coTrusteeFirstName,
      coTrusteeMiddleName,
      coTrusteeLastName,
      coTrusteeDob,
      coTrusteeCitizenship,
      coTrusteeSsn
    }
  } = useContext(FlowContext);

  const [ssnLabel, setSsnLabel] = useState(
    mapCitizenshipToSsnLabel(getDefault(coTrusteeCitizenship?.name))
  );
  const [dobValue, setDobValue] = useState('');
  const [ssnValue, setSSNValue] = useState('');

  const handleCitizenshipBtnClick = ({ target: { value } }) =>
    setSsnLabel(mapCitizenshipToSsnLabel(value));

  return (
    <div key={key} className="section" data-name="coTrusteePIDetails">
      <div className="name-fields">
        <div className="first-name">
          <InputField
            type="text"
            title="First Name"
            {...coTrusteeFirstName}
            name={makeName(coTrusteeFirstName?.name)}
            defaultValue={getDefault(coTrusteeFirstName?.name)}
            className="blocked_data"
            data-name={generateJointOrCoTrustTestID(
              'CoTrustPI',
              'FirstName',
              key
            )}
          />
        </div>

        <div className="middle-name">
          <InputField
            type="text"
            title="Middle Name"
            {...coTrusteeMiddleName}
            name={makeName(coTrusteeMiddleName?.name)}
            defaultValue={getDefault(coTrusteeMiddleName?.name)}
            validation={middlenameValidation}
            className="blocked_data"
            data-name={generateJointOrCoTrustTestID(
              'CoTrustPI',
              'MiddleName',
              key
            )}
          />
        </div>
        <div className="last-name">
          <InputField
            type="text"
            title="Last Name"
            {...coTrusteeLastName}
            name={makeName(coTrusteeLastName?.name)}
            defaultValue={getDefault(coTrusteeLastName?.name)}
            className="blocked_data"
            data-name={generateJointOrCoTrustTestID(
              'CoTrustPI',
              'LastName',
              key
            )}
          />
        </div>
      </div>
      <div className="personal-info-fields">
        <div className="dob-input">
          <InputField
            style={{ paddingRight: '8px' }}
            type="text"
            title="Date of Birth"
            aria-describedby="hint"
            {...coTrusteeDob}
            name={makeName(coTrusteeDob?.name)}
            value={withDefault(dobValue, getDefault(coTrusteeDob?.name))}
            maxLength="10"
            onChange={evt => handleInputFormat(evt, 'DATE', setDobValue)}
            placeholder="mm/dd/yyyy"
            className="blocked_data"
            data-name={generateJointOrCoTrustTestID(
              'CoTrustPI',
              'BirthDate',
              key
            )}
          />
          <dd id="hint" style={{ display: 'none' }}>
            This is a required field. Please enter a two digit month, a two
            digit day and a four digit year for the Date of Birth value.
          </dd>
        </div>
        <div className="ssn-input">
          <InputField
            title={ssnLabel}
            placeholder="000-00-0000"
            maxLength="11"
            onChange={evt => handleInputFormat(evt, 'SSN', setSSNValue)}
            {...coTrusteeSsn}
            name={makeName(coTrusteeSsn?.name)}
            value={withDefault(
              ssnValue,
              formatSsnForDisplay(getDefault(coTrusteeSsn?.name))
            )}
            className="blocked_data"
            data-name={generateJointOrCoTrustTestID('CoTrustPI', 'TaxID', key)}
          />
        </div>
        <div className="citizenship-input joint-owner">
          <RadioGroupField
            title="Citizenship"
            onChange={handleCitizenshipBtnClick}
            {...coTrusteeCitizenship}
            name={makeName(coTrusteeCitizenship?.name)}
            options={[
              {
                title: 'U.S. Citizen',
                value: 'US_CITIZEN',
                defaultChecked:
                  getDefault(coTrusteeCitizenship?.name) === 'US_CITIZEN' ||
                  invalidCitizenshipValue(
                    getDefault(coTrusteeCitizenship?.name)
                  )
              },
              {
                title: 'U.S. Resident Alien',
                value: 'RESIDENT_ALIEN',
                defaultChecked:
                  getDefault(coTrusteeCitizenship?.name) === 'RESIDENT_ALIEN'
              }
            ]}
          />
        </div>
      </div>
      <div className="remove-section-button">
        <MFBeaconButton
          type="button"
          id="removeCoTrustee"
          onClick={removeSection}
          variant="tertiary"
          label="x Remove Co-Trustee"
          data-name={generateJointOrCoTrustTestID(
            'CoTrustPI',
            'RemoveCoTrustButton',
            key
          )}
        />
      </div>
      <hr />
      <style jsx>{styles}</style>
    </div>
  );
};

export default CoTrusteePIDetails;
